import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region ../icons/dist/react/default/airplay-enter.js
const AirPlayEnterIcon = (props, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "currentColor",
	"aria-hidden": "true",
	viewBox: "0 0 18 18",
	ref,
	...props,
	children: [/* @__PURE__ */ jsx("path", { d: "M14.5 2A3.5 3.5 0 0 1 18 5.5v5l-.005.18a3.5 3.5 0 0 1-3.027 3.288L13 12h1.5a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 14.5 4h-11A1.5 1.5 0 0 0 2 5.5v5A1.5 1.5 0 0 0 3.5 12H5l-1.968 1.967A3.5 3.5 0 0 1 0 10.5v-5A3.5 3.5 0 0 1 3.5 2z" }), /* @__PURE__ */ jsx("path", { d: "M8.631 10.902a.5.5 0 0 1 .738 0l4.363 4.76a.5.5 0 0 1-.369.838H4.637a.5.5 0 0 1-.369-.838z" })]
});
const ForwardRef = forwardRef(AirPlayEnterIcon);
//#endregion
export { ForwardRef as default };

//# sourceMappingURL=airplay-enter.js.map